export default "__VITE_ASSET__CHre0w88__"